/**
 * sleep 합니다.
 */
export function sleep(mills: number) {
  return new Promise<void>(r => setTimeout(r, mills));
}
